<template>
  <v-layout row>
    <v-flex 
      sm12 
      md8 
      offset-md2
      xl6
      offset-xl3>
      <v-card>
        <v-toolbar 
          color="primary" 
          dark>
          <v-toolbar-title>Organisations</v-toolbar-title>
        </v-toolbar>
        <v-card-title>
          <v-dialog 
            v-model="dialog" 
            max-width="500px">
            <v-btn 
              slot="activator" 
              color="secondary darken-2" 
              dark 
              class="mb-2">Add organisation</v-btn>
            <v-card>
              <v-card-title>
                <span class="headline">Add organisation</span>
              </v-card-title>
              <v-card-text>
                <v-container grid-list-md>
                  <v-form 
                    ref="form" 
                    v-model="valid"                 
                    lazy-validation>
                    <v-layout wrap>
                      <v-flex 
                        xs12 
                        sm6>
                        <v-text-field 
                          v-model="newUser.username" 
                          :rules="[
                            v => !!v || 'User UID is required',
                            v => !v || v.length <= 14 || 'User UID must be under 15 characters',
                            v => !v || v.length >= 2 || 'User UID must be at least 2 characters',
                            v => /^[a-z]{2,14}$/.test(v) || 'User UID expects lowercase letters only'
                          ]"
                          required
                          label="User UID"/>
                      </v-flex>
                      <v-flex 
                        xs12 
                        sm6>
                        <v-text-field 
                          v-model="newUser.fullname" 
                          :rules="[
                            v => !!v || 'Name is required',
                            v => !v || v.length <= 100 || 'Name must be less than 100 characters',
                          ]"
                          required
                          label="Name"/>
                      </v-flex>
                      <v-flex 
                        xs12 
                        sm6>
                        <v-text-field 
                          v-model="newUser.email" 
                          :rules="[
                            v => !!v || 'E-mail is required',
                            v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
                          ]"
                          required
                          label="Email"/>
                      </v-flex>
                      <v-flex 
                        xs12 
                        sm6>
                        <v-text-field 
                          v-model="newUser.password" 
                          :rules="[
                            v => !!v || 'Password is required',
                            v => /^.*(?=.{8,16})(?=.*\d)(?=.*[A-Za-z]).*$/.test(v) || 'Password must be 8 - 16 characters and contain a digit and letter',
                          ]"
                          required
                          label="Password"/>
                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer/>
                <v-btn 
                  color="blue darken-1" 
                  flat 
                  @click.native="close">Cancel</v-btn>
                <v-btn 
                  color="blue darken-1" 
                  flat 
                  @click.native="save">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-spacer/>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          />
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="organisation"
          :search="search"
          :rows-per-page-items="[10,25,50,{'text':'All','value':-1}]"
          must-sort>
          <template 
            slot="items" 
            slot-scope="props">
            <td>{{ props.item.username }}</td>
            <td>{{ props.item.fullname }}</td>
            <td>
              <!--v-tooltip top>
                <v-icon
                  slot="activator"
                  color="primary"
                  dark
                >visibility</v-icon>
                <span>{{ props.item.password }}</span>
              </v-tooltip-->             
              <span v-if="showPassword[props.index]">{{ props.item.password }}</span>
              <v-btn 
                v-if="!showPassword[props.index]"
                icon
                class="mx-0" 
                @click="onShowPassword(props.index)">
                <v-icon color="secondary">visibility</v-icon>
              </v-btn>
            </td>
            <td>{{ props.item.email }}</td>
            <td>{{ props.item.createdAt.seconds | moment("calendar") }}</td>
            <td class="justify-center layout px-0">              
              <v-btn 
                color="red darken-1"
                icon 
                flat
                @click.prevent="deleteDialog(props.item)"><v-icon>delete</v-icon></v-btn>
            </td>
          </template>
          <v-alert 
            slot="no-results" 
            :value="true" 
            color="error" 
            icon="warning">
            Your search for "{{ search }}" found no results.
          </v-alert>
        </v-data-table>
      </v-card>
    </v-flex>
    <v-dialog 
      v-if="selectedUser" 
      v-model="confirm"
      persistent 
      max-width="290">      
      <v-card>
        <v-card-title class="headline">Delete {{ selectedUser.username }}</v-card-title>
        <v-card-text>{{ selectedUser.fullname }} will no longer have administrator access.</v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn 
            color="blue darken-1" 
            flat 
            @click.native="confirm = false">Close</v-btn>
          <v-btn 
            color="red darken-1" 
            flat 
            @click.native="remove(selectedUser)">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: "Users",
  data: () => ({
    dialog: false,
    confirm: false,
    showPassword: {},
    valid: true,
    search: "",
    headers: [
      { text: "User UID", value: "username" },
      { text: "Organisation", value: "fullname" },
      { text: "Password", value: "password" },
      { text: "Email", value: "email" },
      { text: "Date added", value: "createdAt" },
      { text: "Actions", value: "name", sortable: false }
    ],
    organisation: null,
    newUser: {
      username: null,
      fullname: null,
      email: null,
      password: null
    },
    selectedUser: null
  }),
  firestore() {
    return {
      organisation: this.$store.getters.db
        .collection("organisation")
        .orderBy("fullname")
    };
  },

  methods: {
    deleteDialog(selected) {
      this.selectedUser = selected;
      this.confirm = true;
    },
    editItem(item) {
      // this.editedIndex = this.desserts.indexOf(item)
      this.newUser = Object.assign({}, item);
      this.dialog = true;
    },
    onShowPassword(index) {
      if (this.showPassword.hasOwnProperty(index))
        this.$set(this.showPassword, index, !this.showPassword[index]);
      else this.$set(this.showPassword, index, true);
    },
    save() {
      if (this.$refs.form.validate()) {
        let self = this;
        this.dialog = false;
        this.$store.dispatch("setLoading", false);
        let createdAt = new Date();
        let batch = this.$store.getters.db.batch();
        batch.set(
          this.$store.getters.db
            .collection("organisation")
            .doc(this.newUser.username),
          { ...this.newUser, createdAt }
        );
        batch.set(
          this.$store.getters.db
            .collection("roles/organisation/users")
            .doc(this.newUser.username),
          {
            username: this.newUser.username,
            fullname: this.newUser.fullname,
            email: this.newUser.email,
            createdAt
          }
        );
        batch
          .commit()
          .then(function() {
            console.log("batched it");
            self.$store.dispatch("sendNotification", {
              snackbar: true,
              color: "cyan darken-2",
              text: self.newUser.username + " added"
            });
            // self.$refs.form.reset()
            self.$store.dispatch("setLoading", false);
          })
          .catch(function(err) {
            console.log(err);
            // self.$refs.form.reset()
          });
      }
    },
    remove(item) {
      let self = this;
      this.confirm = false;
      this.$store.dispatch("setLoading", true);
      this.$store.getters.db
        .collection("roles/admin/users")
        .doc(item[".key"])
        .delete()
        .then(function() {
          console.log("Document successfully deleted!");
          self.$store.dispatch("sendNotification", {
            snackbar: true,
            color: "error",
            timeout: 6000,
            text: item.username + " removed"
          });
          self.$store.dispatch("setLoading", false);
          self.selectedUser = null;
        })
        .catch(function(error) {
          console.error("Error writing document: ", error);
          self.$store.dispatch("setLoading", false);
        });
    },
    close() {
      this.$refs.form.reset();
      this.dialog = false;
    }
  }
};
</script>
